export enum SurveyType {
    Workup = 1,
    PreOp = 2,
    Surgery = 3,
    SurgeryPost30 = 4
}